<template>
  <div id="app">
    <keep-alive :include='cashViews'>
      <router-view v-if="isReload"></router-view>
    </keep-alive>
<!--    <router-view/>-->
        <van-tabbar v-model="active" @change="onChange" v-if='$route.meta.showTab' route active-color="#44dda1" inactive-color="#606266">
          <van-tabbar-item replace to="/">
                <span>{{this.active != 0 ? '首页' : '无忧'}}</span>
                <template #icon="props">
                  <img  :src="props.active ? icon1.active : icon1.inactive" />
                </template>
          </van-tabbar-item>
          <van-tabbar-item replace to="/peixun">
               <span>培训</span>
                <template #icon="props">
                  <img :src="props.active ? icon2.active : icon2.inactive" />
                </template>
          </van-tabbar-item>
          <van-tabbar-item replace to="/wode" >
             <span>我的</span>
                <template #icon="props">
                  <img :src="props.active ? icon3.active : icon3.inactive" />
                </template>
          </van-tabbar-item>
        </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    onChange(index) {

    },
    reload() {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      cashViews:['home'],
      isReload: true,
      active: 0,
       icon1: {
        active: require('./assets/images/logo.png'),
        inactive:  require('./assets/icon/shouyeinactive.png'),
      },
       icon2: {
        active: require('./assets/icon/peixunactive.png'),
        inactive:  require('./assets/icon/peixuninactive.png'),
      },
      icon3: {
        active: require('./assets/icon/myactive.png'),
        inactive:  require('./assets/icon/myinactive.png'),
      },

    };
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-color: grey; */
}
.van-tabbar-item__icon img {
    display: block;
    height: 32px;
}
.van-tabbar {
    z-index: 10;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: content-box;
    width: 100%;
    height: 70px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue